import { useEffect, useState } from "react";
import i18n from "../../utils/translations/i18n";
import "./index.scss"
import { Loader } from "../shared/elements/loader";
import { LoaderState } from "../../enums/loader";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { startLoading, stopLoading } from "../../store/application";
import SuccessPage from "./successPage"
import { DNSTrackGAEvent, DNSTrackErrorGAEvent } from "../../utils/analytics/google";
import shippingActions from "../../store/shippingActions";
import axios from 'axios';
declare const window: any;

const { t } = i18n;

const CustomerPreferance = (props: any) => {
    document.title = props.title;
    const {
        applicationState: {user, loadingState },
    } = useSelector((state: RootState) => state);
    const dispatch = useDispatch();
    const [preferance, setPreferance] = useState(false)
    const [email, setEmail] = useState("")
    const [error, setError] = useState("")
    const [success, setSuccess] = useState(false)

    useEffect(() => {
        try {
            let elemets = document.getElementsByClassName('base steps');
            for (var i = 0; i < elemets.length; i++) {
                var div = elemets[i]
                div.setAttribute("style", "display:none");
            }
            document.getElementsByClassName('checkout-contact__number')[0].innerHTML='800-347-7367';
        } catch (error) {
            console.log(error)
        }
        
       
    }, [])

    const updateCustomerPreferance = async () => {
        try {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (email != "" && emailRegex.test(email)) {
                dispatch(startLoading());
                const reCapStatus:any = await dispatch(shippingActions.validatePreferanceReCaptcha(user.userId));
                if(reCapStatus) {
                    let data = {
                        "emailAddress": email,
                        "userConsent": {
                            "rent": preferance ? "N" : "Y"
                        },
                        "countryCode": window.locale_details?.country_code || '',
                        "reference": `website-ABC-${window.locale_details?.country_code.toUpperCase()} DO NOT SELL | Rent form`,
                        "source": window.location.href,
                        "language": window.locale_details?.language || ''
                    };
    
                    await axios.put(`${window.Config?.LAMBDA_CUSTOMER ?? 'https://npr-customer.api.pens.com/'}v1/setCustomerDataPreference`,data, {
                        headers: {
                            [window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key"]: window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8"
                        }})
                        .then((response) => {
                            setSuccess(true);
                            DNSTrackGAEvent(preferance ? 'dns_toggle_on' : 'dns_toggle_off');
                        })
                        .catch((error) => {
                            switch (error.response.status) {
                                case 404:
                                    setError("No matching email found in our records. Please contact customer care for assistance.")
                                    DNSTrackErrorGAEvent('Privacy & Cookie Policy', 'DNS_No matching email found in our records. Please contact customer care for assistance');
                                    break;
                                case 403:
                                    setError("You don't have permission to update your preferences. Please contact support for help")
                                    DNSTrackErrorGAEvent('Privacy & Cookie Policy', "DNS_You don't have permission to update your preferences. Please contact support for help");
                                    break;
                                default:
                                    setError("Something went wrong. Please try again later")
                                    DNSTrackErrorGAEvent('Privacy & Cookie Policy', "DNS_Something went wrong. Please try again later");
                                    break;
                            }
                        });
                }else{
                    window.location.href = window.locale_details.site_baseurl;
                }
            } else {
                setError("Please enter a valid email")
            }
            dispatch(stopLoading());
        } catch (error) {
            console.log('error',error);
            dispatch(stopLoading());
        }


    }
    return (
        <>
            <Loader isVisible={loadingState === LoaderState.START} />
            {success ? <SuccessPage /> : <div id="customer-preferance" className={"main-container"}>
                <span className={"pref-header"}>California Residents: California Consumer Data Privacy Act - CCPA</span>
                <div className="main-bdy">
                    <span className={"pref-subheader"}>Do Not Sell My Personal Information</span>
                    <span className={"pref-detail-text"}>Submit request for opting out from selling/sharing data to National Pen's 3rd parties</span>
                    <div className="email-text-box">
                        <input data-hj-suppress onChange={e => { setEmail(e.target.value) }} onBlur={(e) => {
                            if (e?.target?.value) setError('')
                        }} id="personal-info-last-name" className={error !== "" ? "danger-warn" : ""} name="last-name" type="text" placeholder=" " />
                        <label htmlFor="personal-info-last-name">{t('myac.change_personal_information.email_address')}<dfn title="required">*</dfn></label>
                        {error && <div id="personal-info-last-name_error" className="error pref-err">{error}<br /></div>}
                    </div>
                    <span className="grid-container">
                        <span className="dns-text">
                            Do not allow National Pen to sell/share or rent data to 3rd parties
                        </span>
                        <span className="dns-check">
                            <label className="switch">
                                <input type="checkbox" checked={preferance} onChange={(e) => { setPreferance(e.target.checked) }} />
                                <span className="slider round"></span>
                            </label>
                        </span>
                    </span>
                    <hr className="hr-margin" />
                    <input type="button" className="update-pref-button" onClick={updateCustomerPreferance} value={"Update My Preference"} />
                </div>
            </div>}
        </>
    )
}

export default CustomerPreferance;
